import React, { useState } from 'react';
import './GroupList.css';

const GroupList = ({ groups, selectedGroup, onGroupSelect, currentUser, isCollapsed, onToggleCollapse }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterType, setFilterType] = useState('all');

  const getGroupIcon = (type) => {
    switch (type) {
      case 'class':
        return '🏫';
      case 'club':
        return '🎯';
      case 'parent':
        return '👨‍👩‍👧‍👦';
      case 'general':
        return '📢';
      case 'academic':
        return '📚';
      case 'administrative':
        return '⚙️';
      default:
        return '💬';
    }
  };

  const getGroupColor = (type) => {
    switch (type) {
      case 'class':
        return '#3B82F6';
      case 'club':
        return '#10B981';
      case 'parent':
        return '#F59E0B';
      case 'general':
        return '#8B5CF6';
      case 'academic':
        return '#EF4444';
      case 'administrative':
        return '#6B7280';
      default:
        return '#3B82F6';
    }
  };

  const filteredGroups = groups.filter(group => {
    const matchesSearch = group.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         group.description?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesFilter = filterType === 'all' || group.type === filterType;
    return matchesSearch && matchesFilter;
  });

  const getUnreadCount = (group) => {
    // This would be implemented with actual unread message logic
    return Math.floor(Math.random() * 5); // Placeholder
  };

  const formatLastActivity = (date) => {
    if (!date) return '無活動';
    
    const now = new Date();
    const lastActivity = new Date(date);
    const diffInHours = Math.floor((now - lastActivity) / (1000 * 60 * 60));
    
    if (diffInHours < 1) return '剛剛';
    if (diffInHours < 24) return `${diffInHours}小時前`;
    if (diffInHours < 168) return `${Math.floor(diffInHours / 24)}天前`;
    return lastActivity.toLocaleDateString('zh-TW');
  };

  return (
    <div className={`group-list ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="group-list-header" onClick={onToggleCollapse}>
        <h3>群組列表</h3>
        <p>Group List</p>
        <button 
          className="toggle-button"
          onClick={(e) => {
            e.stopPropagation();
            onToggleCollapse();
          }}
          title={isCollapsed ? "展開群組列表" : "收起群組列表"}
        >
          {isCollapsed ? '▶' : '◀'}
        </button>
      </div>

      <div className="group-list-controls">
        <div className="search-box">
          <input
            type="text"
            placeholder="搜尋群組..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
          <span className="search-icon">🔍</span>
        </div>

        <div className="filter-controls">
          <select
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
            className="filter-select"
          >
            <option value="all">所有類型</option>
            <option value="class">班級</option>
            <option value="club">社團</option>
            <option value="parent">家長</option>
            <option value="general">一般</option>
            <option value="academic">學術</option>
            <option value="administrative">行政</option>
          </select>
        </div>
      </div>

      <div className="groups-container">
        {filteredGroups.length === 0 ? (
          <div className="no-groups">
            <p>沒有找到群組</p>
            <p>No groups found</p>
          </div>
        ) : (
          filteredGroups.map(group => (
            <div
              key={group.id}
              className={`group-item ${selectedGroup?.id === group.id ? 'selected' : ''}`}
              onClick={() => onGroupSelect(group)}
            >
              <div className="group-icon" style={{ backgroundColor: getGroupColor(group.type) }}>
                {getGroupIcon(group.type)}
              </div>
              
              <div className="group-info">
                <div className="group-header">
                  <h4 className="group-name">{group.name}</h4>
                  {getUnreadCount(group) > 0 && (
                    <span className="unread-badge">{getUnreadCount(group)}</span>
                  )}
                </div>
                
                <p className="group-description">
                  {group.description || '無描述'}
                </p>
                
                <div className="group-meta">
                  <span className="group-type">
                    {group.type === 'class' && '班級'}
                    {group.type === 'club' && '社團'}
                    {group.type === 'parent' && '家長'}
                    {group.type === 'general' && '一般'}
                    {group.type === 'academic' && '學術'}
                    {group.type === 'administrative' && '行政'}
                  </span>
                  
                  <span className="member-count">
                    {group.member_count || 0} 成員
                  </span>
                  
                  <span className="last-activity">
                    {formatLastActivity(group.updated_at)}
                  </span>
                </div>
              </div>

              {group.userRole === 'admin' && (
                <div className="admin-badge" title="群組管理員">
                  👑
                </div>
              )}
            </div>
          ))
        )}
      </div>

      {currentUser?.role === 'admin' && (
        <div className="create-group-button">
          <button className="btn-create-group">
            <span>+</span>
            建立新群組
          </button>
        </div>
      )}
    </div>
  );
};

export default GroupList;
